<template>
	<vx-card
        v-if="
                $store.state.auth.role === 'manager' || $store.state.auth.role === 'admin'
                || $store.state.auth.role === 'supervisor'
            "
    >
		<div class="vx-row">
            <div  @click="disableEditing" 
				style="cursor: pointer !important;"
				class="vx-col pt-2 pb-4"
			>{{ $t('informationAboutOrder') }}</div>
			<div @click="enableEditing" 
				style="cursor: pointer !important;"
				class="vx-col pt-2 pb-4"
			>{{ $t('editInformationAboutOrder') }}</div>
			<div class="vx-col pt-2 pb-4"
			>
                <strong>{{ $t('commentAboutOrder') }} </strong>
                <span
                    v-if="countOrderComments > 0"
                    class="status text-sm"
                >
                    {{ countOrderComments }}
                </span>
            </div>
            <div  @click="openTask" 
				style="cursor: pointer !important;"
				class="vx-col pt-2 pb-4"
			>{{ $t('taskAboutOrder') }}
                <span
                    v-if="countOrderTasks.count > 0"
                    class="status text-sm"
                    :class="{ markedDelay: countOrderTasks.delay > 0 }"
                >
                    {{ countOrderTasks.count }}
                </span>
            </div>
		</div>
		<hr class="mb-3">
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="works-add text-center">
                    <vs-custom-button
                        @click="addOrderCommentModal = true">{{ $t('addOrderComment') }}
                    </vs-custom-button>
                </div>
            </div>
        </div>
        <hr class="mb-3 mt-3">
        <div v-if="listComments.length > 0">
            <template
                v-for="(data, index) in listComments"
            >
                <div class="mb-1 frsTitileOrderComment">
                    <div class="frsUserOrderComment">{{ $t(data.userRole) }}: <strong>{{ data.userName }}</strong></div>
                    <div class="frsDateOrderComment">{{ data.created_at }}</div>
                </div>
                <div class="mb-1 frsTextOrderComment" v-html="data.comment">
                </div>
                <hr class="mb-3 mt-3">
            </template>
        </div>
        <div v-else class="text-center">
            {{ $t('noOrderComment') }}
        </div>
        <AddNewCommentToOrder
            :active.sync="addOrderCommentModal"
            @confirm="pushNewCommentToOrder"
        />
    </vx-card>
</template>

<script>
    import databaseManager from "@/mixins/databaseManager";
    import notifier from "@/mixins/notifier";
    import AddNewCommentToOrder from "@/components/dialogs/AddNewCommentToOrder";

    export default {
        name: "CardTicketComment",
        mixins: [databaseManager, notifier],
        props: {
            model: 		            { default: null },
            countOrderComments:     { default: null },
            countOrderTasks:     { default: null },
        },
        components: {
            AddNewCommentToOrder,
        },
        data() {
            return {
                listComments:  { default: [] },
                addOrderCommentModal: false,
            }
        },
        methods: {
            disableEditing() {
                this.$emit("disableEditingOrder");
            },
            enableEditing() {
                this.$emit("enableEditingOrder");
            },
            openTask() {
                this.$emit("showOrderTask");
            },
            async getAllComment() {
                this.listComments = await this.dbViewOrderComments(this.$route.params.id);
                // console.log(this.listComments);
            },
            async pushNewCommentToOrder(newComment) {
                try{
                    await this.dbPushNewCommentToOrder(this.$route.params.id, newComment);
                    this.notifySuccess(`${this.$t('addOrderCommentSuccess')}`);
                    await this.getAllComment();
                    await this.$emit("updateCountOrderComments");
                }catch (e) {
                    this.notifyError(e.message);
                }
            },
        },
        async mounted() {
            try {
                await this.getAllComment();
            } catch(e) {
                this.notifyError(e.message);
            }
        },
    }
</script>

<style lang="scss">
    .frsTitileOrderComment {
        display: flex;
        width: 100%;
    }
    .frsTextOrderComment {
        width: 100%;
    }
    .frsUserOrderComment {
        padding: 0 5px 0 0;
    }
    .frsDateOrderComment {
        margin-left: auto;
        padding: 0 0 0 5px;
    }
</style>